import { render } from "./proofread.vue?vue&type=template&id=32d2e786"
import script from "./proofread.vue?vue&type=script&lang=js"
export * from "./proofread.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__